export default "__VITE_ASSET__gbUjPtLp__"